<template>
  <Navigation :title="$t('changePassword.title')" />
  <div class="container">
    <div class="card my-3">
      <div class="card-body">
        <label for="inputPasswordOld" class="form-label">{{ $t('changePassword.oldPassword') }}</label>
        <div class="input-group">
          <input
            v-if="!showPasswordOld"
            v-model="oldPassword"
            type="password"
            class="form-control"
            :class="{ 'is-invalid': errors['oldPassword'] }"
            id="inputPasswordOld"
            :placeholder="$t('passwordHint')" />
          <input
            v-else
            v-model="oldPassword"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors['oldPassword'] }"
            id="inputPasswordOld"
            :placeholder="$t('passwordHint')" />
          <button class="btn btn-outline-secondary" id="btn-submit" @click="togglePassword('old')" aria-label="Toggle old password visibility">
            <i class="bi" :class="{ 'bi-eye': showPasswordOld, 'bi-eye-slash': !showPasswordOld }"></i>
          </button>
        </div>
        <p class="text-danger mb-3">
          {{ errors['old_password'] }}
        </p>
        <label for="inputPasswordNew" class="form-label">{{ $t('changePassword.newPassword') }}</label>
        <div class="input-group">
          <input
            v-if="!showPasswordNew"
            v-model="newPassword"
            type="password"
            class="form-control"
            :class="{ 'is-invalid': errors['newPassword'] }"
            id="inputPasswordNew"
            :placeholder="$t('passwordHint')" />
          <input
            v-else
            v-model.lazy="newPassword"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors['newPassword'] }"
            id="inputPasswordNew"
            :placeholder="$t('passwordHint')" />
          <button class="btn btn-outline-secondary" id="button-addon2" @click="togglePassword('new')" aria-label="Toggle new password visibility">
            <i class="bi" :class="{ 'bi-eye': showPasswordNew, 'bi-eye-slash': !showPasswordNew }"></i>
          </button>
        </div>
        <p class="text-danger mb-3">
          {{ errors['new_password'] }}
        </p>
        <button
          class="btn btn-primary"
          :class="{ disabled: !Object.values(this.validation).every((item) => item === true) || isLoading }"
          :disabled="isLoading"
          @click="submit_password">
          <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
          {{ $t('changePassword.title') }}
        </button>
      </div>
    </div>
    <div class="validation-hints">
      <span :class="{ 'text-info': this.validation.eight_char }">
        <i class="bi bi-check-circle-fill"></i> {{ $t('validation.minLength', {field: $t('password'), min: '8'}) }}
      </span>
      <br />
      <span :class="{ 'text-info': this.validation.one_numeric }">
        <i class="bi bi-check-circle-fill"></i> {{ $t('validation.minNumeric', {field: $t('password'), min: '1'}) }}
      </span>
      <br />
      <span :class="{ 'text-info': this.validation.one_capital }">
        <i class="bi bi-check-circle-fill"></i> {{ $t('validation.minUppercase', {field: $t('password'), min: '1'}) }}
      </span>
      <br />
      <span :class="{ 'text-info': this.validation.one_lowercase }">
        <i class="bi bi-check-circle-fill"></i> {{ $t('validation.minLowercase', {field: $t('password'), min: '1'}) }}
      </span>
      <br />
      <span :class="{ 'text-info': this.validation.one_symbol }">
        <i class="bi bi-check-circle-fill"></i> {{ $t('validation.minSymbol', {field: $t('password'), min: '1'}) }}
      </span>
      <br />
    </div>
  </div>
</template>

<script>
import Navigation from '../components/Navigation'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'ChangePassword',
  components: { Navigation },
  data() {
    return {
      showPasswordOld: false,
      showPasswordNew: false,
      errors: {},
      oldPassword: '',
      newPassword: '',
      isLoading: false,
      validation: {
        eight_char: false,
        one_numeric: false,
        one_capital: false,
        one_lowercase: false,
        one_symbol: false,
      },
    }
  },
  watch: {
    newPassword: function (value) {
      this.validation.eight_char = value.length >= 8
      this.validation.one_numeric = !!/\d/.test(value)
      this.validation.one_lowercase = !!/[a-z]/.test(value)
      this.validation.one_capital = !!/[A-Z]/.test(value)
      this.validation.one_symbol = !!/[!@#$%^&*()_+\-=[\]{};':"|,.<>?]+/.test(value)
    },
  },
  methods: {
    togglePassword(name) {
      if (name === 'new') {
        this.showPasswordNew = !this.showPasswordNew
      } else {
        this.showPasswordOld = !this.showPasswordOld
      }
    },
    async submit_password() {
      let self = this
      if (this.oldPassword === '') {
        this.errors['old_password'] = self.$t('validation.required', { field: self.$t('changePassword.oldPassword') })
      }
      if (this.newPassword === '') {
        this.errors['new_password'] = self.$t('validation.required', { field: self.$t('changePassword.newPassword') })
      }
      if (this.oldPassword && this.newPassword) {
        this.isLoading = true
        await axios
          .post(
            '/api/change_password',
            {
              user_id: self.$store.getters.getUser.id,
              old_password: self.oldPassword,
              new_password: self.newPassword,
            },
            { withCredentials: true }
          )
          .then((response) => {
            Swal.fire({
              icon: response.data.status ? 'success' : 'error',
              title: response.data.status ? 'Success' : 'Error',
              text: response.data.message,
              showConfirmButton: false,
              timer: 1500,
            })
            if (response.data.status) self.$router.push('/profile')
          })
          .catch((error) => {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.response?.data?.message || 'Failed to change password',
            })
          })
          .finally(() => {
            self.isLoading = false
          })
      }
    },
  },
}
</script>

<style scoped>
.validation-hints {
  font-size: var(--text-sm);
}
</style>
